export const ALL = 'ALL';
export const SKIP_DELETED = 'SKIP_DELETED';
export const NOT_DELETED = 'NOT_DELETED';